import request from "@/utils/request";
// 获取已登录用户信息
export function getUserInfo(data) {
  return request({
    url: "local_exam_general_userinfo",
    method: "GET",
    params: data,
  });
}

// 获取语言包
export function getLanguagePack({ lang }) {
  return request({
    url: "local_exam_general_get_strings",
    method: "GET",
    params: {
      all: 1,
      lang,
    },
  });
}
